import cityValidation from './cityValidation';
import zipValidation from './zipValidation';
const validateField = (field, bookingForm) => {
    if (!field.isModified) {
        return {
            validatedField: field,
        };
    }

    if (field.id === 'city') {
        return cityValidation(field, bookingForm);
    }

    if (field.id === 'postalCode') {
        return zipValidation(field, bookingForm);
    }

    return {
        validatedField: field,
    };
};

const validateForm = ({ formFields, bookingForm }) => {
    return formFields.reduce((validationResult, field) => {
        if (field.fields) {
            const {
                validatedForm: fields,
                isValid,
            } = validateForm({ formFields: field.fields, bookingForm });

            return {
                validatedForm: [
                    ...validationResult.validatedForm,
                    {
                        ...field,
                        fields,
                    },
                ],
                isValid: validationResult.isValid && isValid,
            };
        }

        const {
            validatedField,
            isFieldValid,
        } = validateField(field, bookingForm);

        return {
            validatedForm: [
                ...validationResult.validatedForm,
                validatedField,
            ],
            isValid: validationResult.isValid && isFieldValid !== false,
        };
    }, {
        validatedForm: [],
        isValid: true,
    });
};

const frontEndValidations = (bookingForm) => {
    return validateForm({ formFields: bookingForm.fields, bookingForm });
};

export default frontEndValidations;
